import React, { useEffect, useState } from 'react'
import Api from '../../../../services/Api'
import { INFDetailFormatted } from '../../components/NFTDetail/INFTDetail'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import INFTProperties, { IBaseNFTAttributes } from '../../models/INFTProperties'
import { IAvaxcellsCard } from '../../nftFormats/Avaxcells/Card/IAvaxcellsCard'
import BaseDetail from './BaseDetail'


export default function AvaxcellsDetail(props: INFDetailFormatted) {
  const { tokenItem } = props
  const [detailTokenItem, setDetailTokenItem] = useState<IAvaxcellsCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  function getNFTProperties() {
    let result: INFTProperties[] = []

    if (detailTokenItem && detailTokenItem.attributes) {
      result = detailTokenItem.attributes.map((item: IBaseNFTAttributes) => {
        const newProps = {
          key: item.trait_type,
          value: item.value,
          show: true,
          isUrl: false
        }
        return newProps
      })
    }
    if (detailTokenItem) {
      result = [
        ...result,
        {
          key: 'RARITY',
          value: detailTokenItem.rarity,
          show: true,
          isUrl: true
        },
        {
          key: 'TYPE',
          value: detailTokenItem.type,
          show: true,
          isUrl: true
        },
        {
          key: 'HP',
          value: detailTokenItem.hp,
          show: true,
          isUrl: true
        },
        {
          key: 'STR',
          value: detailTokenItem.str,
          show: true,
          isUrl: true
        },
        {
          key: 'DEF',
          value: detailTokenItem.def,
          show: true,
          isUrl: true
        },
        {
          key: 'SPD',
          value: detailTokenItem.spd,
          show: true,
          isUrl: true
        },
        {
          key: 'BRAINS',
          value: detailTokenItem.brains,
          show: true,
          isUrl: true
        }
      ]
    }

    return result
  }

  function getNFTDescription() {
    return (
      <div>
        Avaxcells Collection
        <p>
          Prepare yourself to create new, genetically modified, AVAXCELLS, with one of the eight elements in existence.
          Would you be able to create a legendary cell? Once the battlefield is ready, get ready to test the power of
          your AVAXCELLS, in ONE vs ONE battle arenas. Create your own AVAXCELLS and prove which one is the best!
        </p>
      </div>
    )
  }
  return (
    <BaseDetail
      {...props}
      description={getNFTDescription()}
      tokenItemName={detailTokenItem ? `${detailTokenItem.name} - ID: ${detailTokenItem.tokenID}` : ''}
      properites={getNFTProperties()}
    >
      {detailTokenItem ? (
        <video
          controls={true}
          controlsList="nodownload"
          width="100%"
          muted
          autoPlay
          loop
          src={`https://ipfs.io/ipfs/${detailTokenItem?.ipfsHash}`}
        />
      ) : (
        <NFTImageSkeleton />
      )}
    </BaseDetail>
  )
}
